import gql from 'graphql-tag';

export const getUserQuery = gql`
  query GetUserQuery($id: String!) {
    getUserQuery(id: $id) {
      _id
      email
      phone
      createdAt
      fullName
      firstName
      lastName
    }
  }
`;

export const filteredUsers = gql`
  query FilteredUsers($usersFilter: usersFilterInput!) {
    filteredUsers(filter: $usersFilter) {
      _id
      email
      type
      fullName
      phone
      permissions {
        orders
        menu
        customers
        promote
        analytics
        settings
        users
        allLocations
        dispensaryIds
        driver
        enterpriseAdmin
        menuReview
        superMenuReview
        messaging
        billing
      }
      dispensaryId
      chainID
      createdAt
      createdBy
      roleAtDispensary
    }
  }
`;

export const exportDispensaryUsers = gql`
  query ExportDispensaryUsers($usersFilter: usersFilterInput!) {
    exportDispensaryUsers(filter: $usersFilter) {
      csv
    }
  }
`;

export const userExistsCheck = gql`
  query UserExistsCheck($input: userIdExistsInput!) {
    userExistsCheck(input: $input) {
      exists
      _id
    }
  }
`;

export const validatePasswordResetTokenQuery = gql`
  query ValidatePasswordResetTokenQuery($token: String!) {
    validatePasswordResetTokenQuery(token: $token) {
      isValid
    }
  }
`;

export const validatePasswordTokenQuery = gql`
  query ValidatePasswordTokenQuery($token: String!) {
    validatePasswordTokenQuery(token: $token) {
      isValid
    }
  }
`;

export const superAdminCustomers = gql`
  query SuperAdminCustomers(
    $customersFilter: superAdminCustomersFilter
    $customersSort: customersSortInput
    $customersPagination: customersPaginationInput
  ) {
    superAdminCustomers(filter: $customersFilter, sort: $customersSort, pagination: $customersPagination) {
      meta {
        totalCount
      }
      customers {
        _id
        email
        createdAt
        ordersTotal
        numOrders
        fullName
        firstName
        lastName
        phone
      }
    }
  }
`;
